
export const filterData = (setBrand, setCategory, productData) => {

    if (setBrand === 'All' && setCategory === "All") return productData;

    //filter only by category for all brands
    if (setBrand === "All") {
        const reg = new RegExp(setCategory.toLowerCase());

        let results1 = productData?.filter((product) => {
            //filter by brand
            let wordStr = product?.category?.toLowerCase();
            if (!setCategory.length) return null;
            return wordStr.match(reg) ? product : null;
        });

        return results1;
    }

    if (setCategory === "All") {
        const reg = new RegExp(setBrand.toLowerCase());

        let results1 = productData?.filter((product) => {
            //filter by brand
            let wordStr = product?.brand?.toLowerCase();
            if (!setBrand.length) return null;
            return wordStr.match(reg) ? product : null;
        });

        return results1;
    }

    var reg1 = new RegExp(setBrand.toLowerCase());
    var reg2 = new RegExp(setCategory.toLowerCase());

    let results1 = productData?.filter((product) => {
        //filter by brand
        let productBrand = product?.brand.toLowerCase();
        let productCategory = product?.category?.toLowerCase();

        if (!setBrand.length || !setCategory.length) return null;
        return productBrand.match(reg1) && productCategory.match(reg2) ? product : null;
    });

    return results1;
}

export const searchData = (searchWord, productData) => {

    var reg = new RegExp(searchWord?.toLowerCase());

    let results = productData.filter((product) => {
        let productName = product?.designation.toLowerCase();
         //filter 
        let productBrand = product?.brand.toLowerCase();
        let productCategory = product?.category?.toLowerCase();

        if (!searchWord.length) return null;
        return (productBrand.match(reg) || productCategory.match(reg) || productName.match(reg)) ? product : null;
    })
    return results;
}


